import { render, staticRenderFns } from "./ReplacementsMerc.vue?vue&type=template&id=0d163791&"
import script from "./ReplacementsMerc.vue?vue&type=script&lang=js&"
export * from "./ReplacementsMerc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports